<app-header></app-header>
<div id="print-section">
<div class="col-lg-12 col-md-12 col-xs-12 success_main">
  <div class="container">
    <p class="col-xs-10" *ngIf="status == 'Success'"><i class="fa fa-check"></i> Invoice Payment
      <span class="smalltxt">Your invoice payment has been processed successfully.</span>
    </p>
    <p class="col-xs-10" *ngIf="status == 'Failure'"><i class="fa fa-exclamation paymentFailure"></i> Invoice Payment
      <span class="smalltxt">Sorry, there was an issue processing your invoice payment.</span>
    </p>

    <span class="success_print col-xs-1"><a (click)=print()><i class="fa fa-print print_icon cursorpointer"></i></a></span>
  </div>
</div>

<div class="container below_header">
  <div class="row">

    <div class="col-lg-12 col-md-12 col-xs-12"> 
      <div>
        <span class="order_id transIDWordBreak">Transaction ID : {{transactionStatus.transactionId}}</span>
      </div>
      
      <div class="detail_list">
        <p *ngIf="transactionStatus.orderIds">
           <b>Order ID(s) :</b> {{transactionStatus.orderIds}}
        </p>
        <p *ngIf="transactionStatus.invoiceIds">
           <b>Invoice ID(s) :</b> {{transactionStatus.invoiceIds}}
        </p>
      </div>
        
      <div class="payment_detail_main">
        <i class="fa fa-credit-card payment_detail_icon"></i>
        <span class="payment_detailtxt">Payment Details</span>

        <div class="blw_paymentdetail">
          <p class="full_paymenttxt" *ngIf="transactionStatus.paymentMode === 'ACH'">Total Net Cash Discount Price</p>
          <p class="full_paymenttxt" *ngIf="transactionStatus.paymentMode === 'CC'">Total Net Regular Price</p>
          <p class="full_payment">{{transactionStatus.amountPaid | currency:'USD'}}</p>
        </div>
      </div>

      <div *ngIf="status == 'Success'" id="goToHome"><button type="button" (click)="home($event)"  class="btn gohome"><i class="fa fa-home home_icon"></i> Go Home</button></div>
      <div *ngIf="status == 'Failure'" id="goToHome"><button type="button" (click)="home($event)"  class="btn gohomeFail"><i class="fa fa-home home_icon"></i> Go Home</button></div>
    </div>
  </div>

</div>
</div>
